import React, { Component } from 'react';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { addDays, addMonths } from 'date-fns';

//import { DateRange } from 'react-date-range';
import {es, enUS, pt} from 'date-fns/locale';
//import { es } from 'react-date-range/src/locale/index.js'
//import 'react-date-range/dist/styles.css'; // main style file
//import 'react-date-range/dist/theme/default.css'; // theme css file

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
//import ListItemIcon from '@material-ui/core/ListItemIcon';
//import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';

import moment from 'moment'
import 'moment/locale/es'
import { withTranslation } from 'react-i18next';
moment.locale('es')
registerLocale('es', es)

const locales = { es: es, en: enUS, pt: pt };

class PeriodScreenshot extends Component {
    constructor(props) {
        super(props);
        //console.log('period', props.range)
        var range={
            selection: {
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection',
            }
        }
        if(props.periodical===true){
            range={
                selection: this.props.range
            }
        }
        this.state = {
            open: false,
            range: {},
            dateRange: range,
            startDate: new Date(),
        }
    }
    onOpenModal = () => {
        this.setState({
            open: true,
            range: {}
        });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    onCloseModalButton = () => {
        this.setState({ open: false });
        Graph(this.props, this.state, 'custom')
    };

    handleRangeChange(which, payload) {
        if(this.props.periodical===true){
            var start=moment(payload.selection.startDate).date(1)._d
            var final=moment(payload.selection.startDate).endOf('month')._d
            if(moment(payload.selection.startDate).date(1).format("DD/MM/YYYY")===moment().date(1).format("DD/MM/YYYY")){
                start=(moment().subtract(1, 'months').date(1)._d)
                final= moment().subtract(1, "months").endOf('month')._d
            }
            this.setState({
                dateRange:{
                    selection: {
                        startDate: start,
                        endDate: final,
                        key: 'selection',
                    }
                }
            })
        }else{
            this.setState({
                [which]: {
                    ...this.state[which],
                    ...payload,
                },
            });
        }
        
        
    }
    handleChange = (startDate) => {
        this.setState({
          startDate,
        });
    };

    createPeriod=()=>{
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        const { open } = this.state;
        const { typeGraph, isOneHour, periodical, startDate} = this.props
        //console.log('rango',this.state.dateRange)
        //console.log('rango period',this.state.dateRange.selection)
        /*if(periodical===true){
            var period=<List>
                            <ListItem>
                                    <Button onClick={this.onOpenModal}>Custom</Button>
                                    <Popover open={open} 
                                            onClose={this.onCloseModal} 
                                            anchorOrigin={{vertical: 'center', horizontal: 'center'}}
                                            transformOrigin={{vertical: 'center', horizontal: 'center' }}>
                                        <div>
                                            <DateRange
                                                maxDate={addDays(new Date(), 0)}
                                                minDate={addMonths(new Date(), -6)}
                                                locale={es}
                                                onChange={this.handleRangeChange.bind(this, 'dateRange')}
                                                moveRangeOnFirstSelection={false}
                                                ranges={[this.state.dateRange.selection]}
                                                className={'PreviewArea'}
                                            />
                                        </div>
                                        <Button onClick={this.onCloseModalButton}>Generar</Button>
                                    </Popover>
                            </ListItem>
                        </List>
            return period
        }*/
        var period=<List>
            { isOneHour ?  
                <ListItem>
                        <Button onClick={() => Graph(this.props, this.state, 'hora')} className="button muted-button">{t('period.text.last-hour')}</Button>
                </ListItem> : null
            }
            <ListItem>
                    <Button onClick={() => Graph(this.props, this.state, '3hora')} className="button muted-button">{t('period.text.last-3-hours')}</Button>
            </ListItem>
            <ListItem>
                <Button onClick={() => Graph(this.props, this.state, '6hora')} className="button muted-button">{t('period.text.last-6-hours')}</Button>
            </ListItem>
            <ListItem>
                <Button onClick={() => Graph(this.props, this.state, '12hora')} className="button muted-button">{t('period.text.last-12-hours')}</Button>
            </ListItem>
            <ListItem>
                <Button onClick={() => Graph(this.props, this.state, 'dia')} className="button muted-button">{t('period.text.last-day')}</Button>
            </ListItem>
            <ListItem>
                    <Button onClick={this.onOpenModal}>Custom</Button>
                    <Popover open={open} 
                            onClose={this.onCloseModal} 
                            anchorOrigin={{vertical: 'center', horizontal: 'center'}}
                            transformOrigin={{vertical: 'center', horizontal: 'center' }}>
                        <div>
                            <DatePicker
                                selected={startDate}
                                onChange={this.handleChange}
                                inline
                                locale={locales[t.lng] || es}
                                maxDate={addDays(new Date(), 0)}
                                minDate={addDays(new Date(), -7)}
                            />
                            
                        </div>
                        <Button onClick={this.onCloseModalButton}>{t('at-select-period.custom-button-submit')}</Button>
                    </Popover>
            </ListItem>
        </List>
        
        return period
    }
    
    render() {
        const { open } = this.state;
        const { typeGraph, isOneHour, periodical} = this.props
        //console.log('render props', this.props)
        return (
            this.createPeriod()
        )
    }
}

function Graph(props, state, id) {
    props.onClick(props.period, props.typeGraph, state.startDate, id)
}


export default withTranslation()(PeriodScreenshot);